import React from 'react';
import { PropTypes } from 'prop-types';
import { StyledMenuItem, ArrowIcon, SubMenuContainer } from './styled';

const MenuItem = ({
  isSelected,
  onClick,
  title,
  icon,
  hasSubMenu,
  subMenu,
  color,
  show,
  disabled,
  capitalize
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  if (!show) return null;

  return (
    <StyledMenuItem
      isSelected={ isSelected }
      onClick={ hasSubMenu ? undefined : onClick }
      onMouseEnter={ () => setIsHovered(true) }
      onMouseLeave={ () => setIsHovered(false) }
      color={ color }
      disabled={ disabled }
      capitalize={ capitalize }
    >
      {icon}
      {title}
      {hasSubMenu && <ArrowIcon />}
      {hasSubMenu && isHovered && (
        <SubMenuContainer>
          {subMenu}
        </SubMenuContainer>
      )}
    </StyledMenuItem>
  );
};

MenuItem.propTypes = {
  show: PropTypes.bool,
  icon: PropTypes.element,
  onClick: PropTypes.func,
  title: PropTypes.string,
  color: PropTypes.string,
  hasSubMenu: PropTypes.bool,
  isSelected: PropTypes.bool,
  subMenu: PropTypes.node
};

MenuItem.defaultProps = {
  isSelected: false,
  onClick: () => {},
  title: '',
  color: '',
  hasSubMenu: false,
  show: true,
  icon: null
};

export default MenuItem;
